import service from "@/api/service";
import { GetResponse } from "@/api/ticket-list/response";
import { GetRequest } from "@/api/ticket-list/request";

/**
 * プッシュメッセージデジタルチケット取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-ticket-list", getRequest);
  return response.data as GetResponse;
}
